import { Box, Flex, HStack, Image, Link, Text, useBreakpointValue } from "@chakra-ui/react"
import { BiLogoFacebookCircle } from "react-icons/bi"
import { FaInstagram, FaMapMarkerAlt, FaPhoneAlt, FaTwitter } from "react-icons/fa"
import styles from "../Style/Style.module.css";
import { wordpressBaseUrl } from "../../../wordpressApiConfig/wordpressApiConfig";
import { IoLogoLinkedin } from "react-icons/io5";
import { AiOutlineMail } from "react-icons/ai";
import { useEffect } from "react";
import { getObjectUrlFromBlob } from "../../../GlobalActions/getImageFromBlob";
import { useState } from "react";
import { getImageBaseUrl } from "../../../Helper/env";


export const Footer = () => {
    const wpBaseUrl = wordpressBaseUrl();
    const handleOpen = (link: string) => {
        window.open(link)
    }

    // Determine if we're in mobile view
    const isMobile = useBreakpointValue({ base: true, lg: false });

    const [pocoLogo, setPocoLogo] = useState("");
    const [appStoreLogo,setAppStoreLogo] = useState("");
    const [googlePlayLogo,setGooglePlayLogo] = useState("");

    useEffect(() => {
        let pocoLogoUrl:any, appStoreLogoUrl:any, googlePlayLogoUrl:any;
        const fetchLogos = async () => {
          try {
            pocoLogoUrl = await getObjectUrlFromBlob(`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/logos/pococare-logo.png`);
            setPocoLogo(pocoLogoUrl);
          } catch (err) {
            console.error("Error fetching Poco logo:", err);
          }
      
          try {
            appStoreLogoUrl = await getObjectUrlFromBlob(`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/logos/appstore.jpg`);
            setAppStoreLogo(appStoreLogoUrl);
          } catch (err) {
            console.error("Error fetching App Store logo:", err);
          }
      
          try {
            googlePlayLogoUrl = await getObjectUrlFromBlob(`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/logos/google-play.jpg`);
            setGooglePlayLogo(googlePlayLogoUrl);
          } catch (err) {
            console.error("Error fetching Google Play logo:", err);
          }
        };
      
        fetchLogos();
      }, []);

    return (
        <Box width={"100%"} background={"rgba(68, 149, 196, 0.06)"} margin={"auto"}>
            <Box width={"100%"} paddingX={isMobile ? "10px" : "40px"} paddingTop={isMobile ? "30px" : "70px"} paddingBottom={isMobile ? "30px" : "45px"}>
                <HStack flexDir={isMobile ? "column" : "row"} spacing={isMobile ? 4 : 8} justifyContent={isMobile ? "center" : "space-evenly"} alignItems={isMobile ? "center" : "flex-start"}>
                    <Flex direction="column" alignItems={isMobile ? "center" : 'flex-start'} gap={5} padding={"10px"}>
                        <Image
                            src={pocoLogo}
                            width={isMobile ? "170px" : "234px"}
                            height={isMobile ? "68.29px" : "94px"}
                            marginBottom={"10px"}
                            style={{ mixBlendMode: "multiply" }}
                        />
                        <Flex alignItems={'flex-start'} gap={4} py={"10px"}>
                            {/* Facebook Icon */}
                            <Box
                                as="button"
                                // onClick={() => handleOpen("https://www.facebook.com/pococare")}
                                color="white"
                                bg="#12c395"
                                borderRadius="50%"
                                p={1}
                                _hover={{ bg: "rgba(254, 29, 143, 1)" }}
                                transition="background-color 0.3s ease"
                                fontSize="18px"
                                height={"32px"}
                                width={"32px"}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                            >
                                <BiLogoFacebookCircle />
                            </Box>

                            {/* Twitter Icon */}
                            <Box
                                as="button"
                                // onClick={() => handleOpen("https://www.twitter.com/pococare")}
                                color="white"
                                bg="#12c395"
                                borderRadius="50%"
                                p={1}
                                _hover={{ bg: "rgba(254, 29, 143, 1)" }}
                                transition="background-color 0.3s ease"
                                fontSize="18px"
                                height={"32px"}
                                width={"32px"}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                            >
                                <FaTwitter />
                            </Box>

                            {/* Instagram Icon */}
                            <Box
                                as="button"
                                // onClick={() => handleOpen("https://www.instagram.com/pococare")}
                                color="white"
                                bg="#12c395"
                                borderRadius="50%"
                                p={1}
                                _hover={{ bg: "rgba(254, 29, 143, 1)" }}
                                transition="background-color 0.3s ease"
                                fontSize="18px"
                                height={"32px"}
                                width={"32px"}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                            >
                                <FaInstagram />
                            </Box>

                            {/* LinkedIn Icon */}
                            <Box
                                as="button"
                                onClick={() => handleOpen("https://www.linkedin.com/company/pococare/")}
                                color="white"
                                bg="#12c395"
                                borderRadius="50%"
                                p={1}
                                _hover={{ bg: "rgba(254, 29, 143, 1)" }}
                                transition="background-color 0.3s ease"
                                fontSize="18px"
                                height={"32px"}
                                width={"32px"}
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                            >
                                <IoLogoLinkedin />
                            </Box>
                        </Flex>
                        <Flex gap={2}>
                            <Image
                                src={googlePlayLogo}
                                style={{ width: isMobile ? "147px" : "103px", height: isMobile ? "49.73px" : "39px", objectFit: "contain" }}
                                alt="App Store"
                                onClick={() => handleOpen("https://play.google.com/store/apps/details?id=com.pococare.pocoemurgency")}
                            />
                            <Image
                                src={appStoreLogo}
                                style={{ width: isMobile ? "147px" : "103px", height: isMobile ? "49.73px" : "39px", objectFit: "contain" }}
                                alt="Ios Store"
                                onClick={() => handleOpen("https://apps.apple.com/in/app/poco-emurgency/id6639608537")}
                            />
                        </Flex>
                    </Flex>
                    <Flex direction="column" alignItems={isMobile ? "center" : 'flex-start'} gap={2.5} padding={"10px"}>
                        <Text className={styles.footerListMainText}>About Us</Text>
                        <Text className={styles.footerListSubText}>Our Founders</Text>
                        <Text className={styles.footerListSubText}>Key Team Members</Text>
                        <Text className={styles.footerListSubText}>Awards & recognition</Text>
                        <Text className={styles.footerListSubText}>News & Media</Text>
                    </Flex>
                    <Flex direction="column" alignItems={isMobile ? "center" : 'flex-start'} gap={2.5} padding={"10px"}>
                        <Text className={styles.footerListMainText}>Pococare Advantages</Text>
                        <Text className={styles.footerListSubText}>End To End</Text>
                        <Text className={styles.footerListSubText}>Beyond Ambulance</Text>
                        <Text className={styles.footerListSubText}>Personalized Readiness</Text>
                        <Text className={styles.footerListSubText}>Intelligent Ambulance Dispatch</Text>
                        <Text className={styles.footerListSubText}>Intelligent Hospital Finder</Text>
                        <Text className={styles.footerListSubText}>Data & Cyber Security</Text>
                    </Flex>
                    <Flex direction="column" alignItems={isMobile ? "center" : 'flex-start'} gap={2.5} padding={"10px"}>
                        <Text className={styles.footerListMainText}>Useful Links</Text>
                        <Link href={`${wpBaseUrl}/contact-us/`} className={styles.footerListSubText}>
                            Contact Us
                        </Link>
                        <Link href={"https://pococare.com/terms&conditions/"} isExternal className={styles.footerListSubText}>
                            Terms & Conditions
                        </Link>
                        <Link href="https://pococare.com/privacyPolicy/" isExternal className={styles.footerListSubText}>
                            Privacy Policy
                        </Link>
                        <Link href="https://pococare.com/Pococare_Refund_Policy.pdf" isExternal className={styles.footerListSubText}>
                            Refund Policy
                        </Link>
                    </Flex>
                    <Flex direction="column" alignItems={isMobile ? "center" : 'flex-start'} gap={2.5} padding={"10px"}>
                        <Text className={styles.footerListMainText}>Pococare</Text>
                        <Text className={styles.footerListSubText}>Our Vision</Text>
                        <Text className={styles.footerListSubText}>Our Mission</Text>
                        <Text className={styles.footerListSubText}>Our Values - Pocoways</Text>
                    </Flex>
                    <Flex direction="column" alignItems={isMobile ? "center" : 'flex-start'} gap={2.5} padding={"10px"}>
                        <Text className={styles.footerListMainText}>Contact Us</Text>
                        <Flex align="center" gap={2}>
                            <FaMapMarkerAlt color="black" size={15} />
                            <Text className={styles.footerListSubText}>Bengaluru, India</Text>
                        </Flex>
                        <Flex align="center" gap={2} cursor="pointer" as="a" href="tel:+918056066766">
                            <FaPhoneAlt color="black" size={15} />
                            <Text className={styles.footerListSubText}>+91 8056066766</Text>
                        </Flex>

                        <Flex align="center" gap={2} cursor="pointer" as="a" href="mailto:info@pococare.com">
                            <AiOutlineMail color="black" size={15} />
                            <Text className={styles.footerListSubText}>info@pococare.com</Text>
                        </Flex>


                    </Flex>
                </HStack>
                <Box>
                    <Text
                        as="p"
                        fontFamily={"Poppins"}
                        fontSize={"13px"}
                        fontWeight="300"
                        textAlign="center"
                        color="rgba(0, 0, 0, 0.51)"
                        lineHeight={"36px"}
                        marginTop={"40px"}
                    >
                        © 2025 Copyright POCOCARE. All Rights Reserved
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}